export default "__VITE_ASSET__CM1xLP2K__"